<motn-subnav
  [items]="subnavItems"
></motn-subnav>

@if (childApp) {
  <div class="manage-unit">
    <div class="section">
      <h3>
        Tenant Unit
        <span
          class="button small yellow"
          [innerText]="childApp.Name"
        ></span>
      </h3>

      <input
        [(ngModel)]="childApp.Name"
        (ngModelChange)="editedName=true"
      >

      <div class="label">Name</div>

      <button
        (click)="submitName()"
        [ngClass]="{'small': 1, 'loading': submittingName, 'inactive': !editedName}"
      >
        <span>Save</span>
        <motn-spinner></motn-spinner>
      </button>

    </div>

    <div class="section">
      <h3>
        Modules
        <span
          class="button small yellow"
          [innerText]="childApp.Name"
        ></span>
      </h3>

      @if (childApp?.Config?.Template?.Type === 'occupant-tenant') {
        <motn-configure-occupant-tenant
          class="item"
          [app]="childApp"
        ></motn-configure-occupant-tenant>
      }
    </div>
  </div>
}
